import { render } from "./MessengerAccounts.vue?vue&type=template&id=719dfa5a&scoped=true"
import script from "./MessengerAccounts.vue?vue&type=script&lang=js"
export * from "./MessengerAccounts.vue?vue&type=script&lang=js"

import "./MessengerAccounts.vue?vue&type=style&index=0&id=719dfa5a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-719dfa5a"]])

export default __exports__